<template>
    <div class="shadow rounded-lg"
         :class="{ 'bg-white': ! muted, 'bg-cool-gray-50': muted }"
    >
        <div class="border-b border-gray-200 px-4 py-5 sm:px-6 flex items-center justify-between"
             v-if="heading"
        >
            <h4 class="text-lg leading-6 text-gray-900" v-html="heading"></h4>
            <slot name="header"
                  :toggle-collapsed="toggleCollapsed"
                  :is-collapsed="collapsed"
            ></slot>
        </div>

        <div class="px-4 sm:px-6"
             :class="{ 'py-5 sm:py-6': ! collapsable || ! collapsed, 'h-0 py-0 overflow-hidden': collapsable && collapsed }"
        >
            <slot></slot>
        </div>

        <div class="bg-gray-50 px-4 py-4 sm:px-6 rounded-b-lg" v-if="$slots.footer">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
	export default {
	    data() {
	        return {
	            collapsed: true,
            }
        },

		props: {
		    heading: {
		        type: String,
            },

            muted: {
		        type: Boolean,
                default: false
            },

            collapsable: {
		        type: Boolean,
                default: false,
            }
        },

        methods: {
	        toggleCollapsed() {
	            this.collapsed = ! this.collapsed;
            }
        }
	}
</script>
